import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-slate-100"><XCircle className="h-8 w-8 text-slate-500" /></div>
        <h1 className="mt-5 text-xl font-bold text-slate-900">Checkout cancelled</h1>
        <p className="mt-1 text-sm text-slate-500">No charge was made. You can pick a plan whenever you're ready.</p>
        <Button onClick={() => navigate('/billing')} className="mt-6 w-full bg-blue-600 hover:bg-blue-700"><ArrowLeft className="mr-1.5 h-4 w-4" /> Back to Plans</Button>
      </div>
    </div>
  );
}
